import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../../../core/RandomLCG.js";
import "../../../../webgl/BufferObject.js";
import "../../../../webgl/FramebufferObject.js";
import "../../../../../core/has.js";
import "../../../../webgl/checkWebGLError.js";
import "../../../../webgl/enums.js";
import "../../../../../chunks/builtins.js";
import t from "../../../../webgl/Texture.js";
import "../../../../webgl/VertexArrayObject.js";
import { TEXTURE_BINDING_RENDERER_0 as o, TEXTURE_BINDING_RENDERER_1 as r, TILE_SIZE as i } from "../definitions.js";
import { WGLGeometryType as s } from "../enums.js";
import { createProgramDescriptor as a } from "../Utils.js";
import n from "./WGLGeometryBrush.js";
import { FillMaterialKey as l } from "../materialKey/MaterialKey.js";

var u = function u(e) {
  var t = {
    geometry: [{
      location: 0,
      name: "a_pos",
      count: 2,
      type: 5122
    }, {
      location: 1,
      name: "a_id",
      count: 3,
      type: 5121
    }, {
      location: 2,
      name: "a_bitset",
      count: 1,
      type: 5121
    }]
  };
  return e.dotDensity ? (t.geometry.push({
    location: 3,
    name: "a_inverseArea",
    count: 1,
    type: 5126
  }), a(e.data, t)) : (t.geometry.push({
    location: 3,
    name: "a_color",
    count: 4,
    type: 5121,
    normalized: !0
  }), e.simple || t.geometry.push({
    location: 4,
    name: "a_aux1",
    count: 4,
    type: 5123
  }), t.geometry.push({
    location: 5,
    name: "a_aux2",
    count: 4,
    type: 5121
  }, {
    location: 6,
    name: "a_aux3",
    count: 4,
    type: 5121
  }), e.simple || t.geometry.push({
    location: 7,
    name: "a_zoomRange",
    count: 2,
    type: 5123
  }), a(e.data, t));
};

var d = /*#__PURE__*/function (_n) {
  _inherits(d, _n);

  var _super = _createSuper(d);

  function d() {
    var _this;

    _classCallCheck(this, d);

    _this = _super.apply(this, arguments), _this._dotTextureSize = 0, _this._dotTextures = null, _this._dotSamplers = new Int32Array([o, r]);
    return _this;
  }

  _createClass(d, [{
    key: "dispose",
    value: function dispose() {
      this._disposeTextures();
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return s.FILL;
    }
  }, {
    key: "drawGeometry",
    value: function drawGeometry(e, t, o, r) {
      var s = e.context,
          a = e.painter,
          n = e.rendererInfo,
          _d = e.requiredLevel,
          m = l.load(o.materialKey),
          _u = u(m),
          c = _u.bufferLayouts,
          f = _u.attributes,
          p = a.materialManager.getMaterialProgram(e, m, "materials/fill", f, r);

      if (s.useProgram(p), this._setSharedUniforms(p, e, t), p.setUniform2f("u_tileOffset", 512 * t.key.col, 512 * t.key.row), m.textureBinding) {
        a.textureManager.bindTextures(s, p, m);

        var _o = 1 / Math.pow(2, _d - t.key.level) / e.pixelRatio;

        p.setUniform1f("u_zoomFactor", _o);
      }

      var _ = 1 / e.pixelRatio;

      if (p.setUniform1f("u_blur", _), p.setUniform1f("u_antialiasing", _), this._setSizeVVUniforms(m, p, n, t), this._setColorAndOpacityVVUniforms(m, p, n), m.dotDensity) {
        var _o2 = i / n.ddDotSize,
            _r = _o2 * window.devicePixelRatio * _o2 * window.devicePixelRatio,
            _a = 1 / Math.pow(2, _d - t.key.level),
            _l = 1 / _a * (1 / _a),
            _u2 = n.ddDotScale ? e.state.scale / n.ddDotScale : 1;

        p.setUniform1f("u_tileZoomFactor", _a), p.setUniform1f("u_tileDotsOverArea", _r / (i * window.devicePixelRatio * i * window.devicePixelRatio)), p.setUniformMatrix4fv("u_dotColors", n.ddColors), p.setUniform4fv("u_isActive", n.ddActiveDots), p.setUniform4fv("u_dotBackgroundColor", n.ddBackgroundColor), p.setUniform1f("u_dotValue", Math.max(1, n.ddDotValue * _u2 * _l)), this._bindDotDensityTextures(s, p, n, _o2);
      }

      o.draw(s, c, f);
    }
  }, {
    key: "_disposeTextures",
    value: function _disposeTextures() {
      if (this._dotTextures) {
        for (var _e = 0; _e < this._dotTextures.length; _e++) {
          this._dotTextures[_e].dispose();
        }

        this._dotTextures = null;
      }
    }
  }, {
    key: "_bindDotDensityTextures",
    value: function _bindDotDensityTextures(e, t, o, r) {
      var i = this._createDotDensityTextures(e, r, o.ddSeed);

      t.setUniform1iv("u_dotTextures", this._dotSamplers);

      for (var _s = 0; _s < i.length; _s++) {
        e.bindTexture(i[_s], this._dotSamplers[_s]);
      }
    }
  }, {
    key: "_createDotDensityTextures",
    value: function _createDotDensityTextures(t, o, r) {
      if (this._dotTextureSize === o && this._seed === r || (this._disposeTextures(), this._dotTextureSize = o, this._seed = r), null === this._dotTextures) {
        var _i = new e(r);

        this._dotTextures = [this._allocDotDensityTexture(t, o, _i), this._allocDotDensityTexture(t, o, _i)];
      }

      return this._dotTextures;
    }
  }, {
    key: "_allocDotDensityTexture",
    value: function _allocDotDensityTexture(e, o, r) {
      var i = new Float32Array(o * o * 4);

      for (var _t = 0; _t < i.length; _t++) {
        i[_t] = r.getFloat();
      }

      return new t(e, {
        wrapMode: 10497,
        pixelFormat: 6408,
        dataType: 5126,
        samplingMode: 9728,
        width: o,
        height: o
      }, i);
    }
  }]);

  return d;
}(n);

export { d as default };